<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">申请记录</div>
            <div class="page-back" @click="toBack">返回</div>
        </div>
        <empty v-if="lists.length === 0" :type="2"/>
        <div class="flex flex-direction">
            <div class="item flex flex-direction justify-center" v-for="(item,index) in lists" :key="index">
                <div class="title ovHide">{{item.title}}</div>
                <div class="content ovHide2">
                    {{item.desc}}
                </div>
                <div class="flex  flex-wrap align-center  margin-top-sm">
                    <div class="count"><span>{{item.son.length}}</span>项服务</div>
                    <div class="tag">已申请{{item.apply_count}}项</div>
                </div>
                <div class="item-service flex flex-direction align-center justify-center"
                     v-for="(service,index) in item.son" :key="index">
                    <div class="title">{{service.title}}</div>
                    <div class="content">{{service.content}}</div>
                    <el-button class="operate" :disabled="service.status === 1">{{service.status === 1 ? '已申请' :'申请服务'}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getServerRecord} from '@/api/branch'
    export default {
        components: {},
        name: "serviceRecord",
        data() {
            return {
                lists: [],
            }
        },
        created() {
            this.$emit('setIndex', [5, 3], '申请记录')
            this.init()
        },
        computed: {},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getServerRecord()
                if (_data.status === 200) {
                   _data.data.map(item=>{
                       item.apply_count = item.son.filter(s=> s.status === 1).length
                   })
                    this.lists = _data.data
                }
            },
            toBack(){
                this.$router.go(-1)
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .item {
            width: 100%;
            background-color: #f3f7fb;
            border-radius: 10px;
            margin-top: 20px;
            padding: 25px 20px;
            .title {
                font-size: 22px;
                line-height: 22px;
                color: #0a2240;
            }
            .content {
                width: 100%;
                font-size: 16px;
                line-height: 20px;
                color: #7889a4;
                margin-top: 19px;
            }
            .tag {
                font-size: 14px;
                color: #0a2240;
                margin-top: 15px;
                margin-right: 20px;
            }
            .item-service {
                width: 100%;
                background-color: #ffffff;
                border-radius: 10px;
                padding: 30px;
                margin-top: 20px;
                .title {
                    font-size: 22px;
                    font-weight: bold;
                    color: #0a2240;
                }
                .content {
                    font-size: 14px;
                    line-height: 24px;
                    color: #0a2240;
                    margin-top: 22px;
                }
                .operate {
                    width: 110px;
                    height: 36px;
                    line-height: 36px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    margin-top: 20px;
                    padding: 0;
                    &.white {
                        background: #ffffff none;
                        color: #ff9600;
                    }
                    &:disabled {
                        background: #b4c7e5 none;
                    }
                }
            }
        }
    }

</style>